module.exports = __webpack_public_path__ + "img/export-csv.a0c534d3.svg";